import React from 'react';

import {ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {UseArtifactsResult} from 'llm/chat-library/useArtifacts';

import {LegacyDataImportSideBySideLayout} from './LegacyDataImportSideBySideLayout';
import {SideBySideLayout} from './SideBySideLayout';

/**
 * Props passed to chat layout components.
 */
export interface ChatLayoutProps {
  /** The chat content (message thread + input) */
  chatContent: JSX.Element;
  /** Artifacts from useArtifacts hook */
  artifacts: UseArtifactsResult;
  /** Whether the document is editable */
  isEditable: boolean;
}

/**
 * A component that renders a chat layout.
 */
export type ChatLayoutComponent = React.ComponentType<ChatLayoutProps>;

/**
 * Get the appropriate layout component for a chat type.
 *
 * Most chat types use the standard two-panel layout (chat + artifact).
 * LDI uses a custom three-panel layout (chat + document + source file).
 */
export function getChatLayout(chatType: ChatType): ChatLayoutComponent {
  switch (chatType) {
    case ChatType.LEGACY_DATA_IMPORT:
      return LegacyDataImportSideBySideLayout;
    default:
      return SideBySideLayout;
  }
}
